import 'core-js/es6/map';
import 'core-js/es6/set';
import 'raf/polyfill';

import React, { Component } from 'react';
import 'babel-polyfill';
import './App.css';
import 'antd/dist/antd.css';

import {
  BrowserRouter as Router,
} from "react-router-dom";

import Display from './components/Display';
//import SlideLanding from './components/SlideLanding';

class App extends Component {
  componentDidMount(){
    
  }
  render() {
    return (
      <Router>
        {/* <Home /> */}
        {/* <SlideLanding/> */}
        <div id="display">
          <Display />
        </div>
      </Router>
    );
  }
}

export default App;
